// Durum filtresi: çoklu seçim, her değişiklik kullanıcıya özel sunucuda saklanır ve her girişte uygulanır
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ChevronDown } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_OPTIONS = [
  ['aktif', 'Onaylandı'], ['taslak', 'Taslak'], ['eksik_hatali', 'Eksik/Hatalı'], ['talep_bilgisi_hatali', 'Talep Bilgisi Hatalı'],
  ['isg_inceleme', 'İSG İncelemesinde'], ['onay_bekliyor', 'Onay Bekliyor'], ['red_edildi', 'Reddedildi'], ['suresi_dolmus', 'Süresi Dolmuş'],
  ['magaza_itirazi', 'Mağaza itirazı olanlar'], ['dusuk_puan', 'Düşük puanlı firmalar'],
];

// [seçili durumlar, geçici değiştir (banner/dashboard), değiştir+kaydet]
export const usePersistedStatuses = (roleDefault, skipApply) => {
  const [sel, setSel] = useState(roleDefault);
  const skip = useRef(skipApply);
  useEffect(() => {
    axios.get(`${API}/auth/permit-filter-default`).then(r => {
      if (Array.isArray(r.data.statuses) && !skip.current) setSel(r.data.statuses);
    }).catch(() => {});
  }, []);
  const setTemp = (v) => setSel(v === 'all' ? [] : [v]);
  const setSaved = (next) => {
    setSel(next);
    axios.put(`${API}/auth/permit-filter-default`, { statuses: next }).catch(() => toast.error('Filtre tercihi kaydedilemedi'));
  };
  return [sel, setTemp, setSaved];
};

export const StatusMultiFilter = ({ value, onChange, hideLowScore }) => {
  const opts = STATUS_OPTIONS.filter(([k]) => !(hideLowScore && k === 'dusuk_puan'));
  const labels = opts.filter(([k]) => value.includes(k)).map(([, l]) => l);
  const toggle = (k, on) => onChange(on ? [...value, k] : value.filter(x => x !== k));
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="flex h-9 w-56 items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 text-sm shadow-sm transition-colors hover:bg-slate-50" data-testid="status-filter-permits">
          <span className="truncate text-left">{labels.length === 0 ? 'Tümü' : labels.length <= 2 ? labels.join(', ') : `${labels.length} durum seçili`}</span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-1" data-testid="status-filter-list">
        {opts.map(([k, l]) => (
          <label key={k} className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm hover:bg-slate-100" data-testid={`status-option-${k}`}>
            <Checkbox checked={value.includes(k)} onCheckedChange={(v) => toggle(k, !!v)} data-testid={`status-check-${k}`} />{l}
          </label>
        ))}
        <div className="mt-1 flex items-center justify-between border-t px-2 pt-1.5 pb-1 text-xs text-slate-500">
          <span>{value.length ? `${value.length} seçili` : 'Hepsi gösteriliyor'}</span>
          {value.length > 0 && <button type="button" onClick={() => onChange([])} className="font-semibold text-orange-600 hover:underline" data-testid="status-filter-clear">Temizle (Tümü)</button>}
        </div>
        <p className="px-2 pb-1 text-[11px] text-slate-400">Seçiminiz otomatik kaydedilir.</p>
      </PopoverContent>
    </Popover>
  );
};
